import React, { useMemo, useRef } from 'react'
import { Calendar } from 'primereact/calendar';

const MAX_RANGE_MONTHS = 2;

const addMonths = (date, months) => {
    const result = new Date(date);
    result.setMonth(result.getMonth() + months);
    return result;
};

function DateRangeSelection({ dates, setDates }) {
    const calendarRef = useRef(null);

    const { minDate, maxDate } = useMemo(() => {
        if (dates?.[0] && !dates?.[1]) {
            return {
                minDate: dates[0],
                maxDate: addMonths(dates[0], MAX_RANGE_MONTHS),
            };
        }
        return { minDate: null, maxDate: null };
    }, [dates]);

    const handleDateSelect = (e) => {
        let value = e.value;

        if (value?.[0] && value?.[1]) {
            const maxEndDate = addMonths(value[0], MAX_RANGE_MONTHS);
            if (value[1] > maxEndDate) {
                value = [value[0], maxEndDate];
            }
        }

        setDates(value);

        if (value?.[0] && calendarRef.current && value?.[1]) {
            calendarRef.current.hide();
        }
    };

    return (
        <Calendar
            value={dates}
            onChange={handleDateSelect}
            selectionMode="range"
            readOnlyInput
            ref={calendarRef}
            hideOnDateTimeSelect
            dateFormat="dd/mm/yy"
            minDate={minDate}
            maxDate={maxDate}
        />
    )
}

export default DateRangeSelection